"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreUsersAdminPatchSlice = void 0;
const patchAdminChangePermission_1 = require("../../../api/users/patchAdminChangePermission.js");
const actions_1 = require("../../customers/_id/users/actions.js");
const actions_2 = require("../_idMap/actions.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.coreUsersAdminPatchSlice = (0, xuder_1.createPatchAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSagaWithFn)((action) => {
                const { isLocked, isReadOnly } = action.data;
                if (isReadOnly !== undefined) {
                    return {
                        data: { isReadOnly },
                        id: sonar_analytics_1.AMPLITUDE_EVENT.USER_PERMISSIONS_UPDATED
                    };
                }
                else if (isLocked !== undefined) {
                    return {
                        data: { isLocked },
                        id: sonar_analytics_1.AMPLITUDE_EVENT.USER_STATUS_UPDATED
                    };
                }
                return undefined;
            }),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        successCombinationActionCreators: [
            actions_1.updateCustomerUser,
            (request) => {
                const update = {
                    userId: request.userId
                };
                if (request.isLocked !== undefined) {
                    update.isLocked = request.isLocked;
                }
                if (request.isReadOnly !== undefined) {
                    update.isReadOnly = request.isReadOnly;
                }
                return (0, actions_2.updateUserReferences)([update]);
            }
        ]
    },
    name: 'CoreUsersAdmin',
    receive: false,
    request: true,
    requestHandler: patchAdminChangePermission_1.patchAdminChangePermission,
    retainDataOnRequest: false
});
//# sourceMappingURL=patch.js.map